import React from "react";
import { useTranslation } from "react-i18next";
import ButtonComponent from "@components/ButtonComponent";
import { CLOSE_SUBMENU_TIMEOUT } from "./constants";
import { useTheme } from "@stores/ThemeContext";

const SubMenu = ({
  id,
  type,
  addType,
  parent,
  isTerminal,
  sentTerminalId,
  actions,
  onClose,
}) => {
  const testId = id.id || id;
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <>
      <div
        className="fixed w-screen h-screen bg-black opacity-10 z-[24] top-0 left-0"
        onClick={() => {
          setTimeout(() => {
            onClose();
          }, CLOSE_SUBMENU_TIMEOUT);
        }}
      ></div>
      <div
        className={`absolute dark:bg-gray-700 flex flex-col bottom-0 left-0 ltr:-translate-x-full translate-y-full justify-around w-max rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 z-[25]`}
      >
        {actions.map((action, index) => {
          return (
            <ButtonComponent
              data-testid={`action-button-${testId}-${action.value}`}
              key={index}
              type="subButton"
              align="start"
              withoutborder={true}
              onClick={() => action.action(id, type, parent, sentTerminalId)}
              text={action.name}
              className={`justify-end text-${action.color ? action.color : (isDarkMode ? "white" : "primary-700")} ${
                !action.color && "hover:text-primary-500"
              }`}
              noTextSwap={true}
            />
          );
        })}
      </div>
    </>
  );
};

export default SubMenu;
